import { Media, type Image } from '@gql-generated/graphql'

type GenerateImageTypeFromUrlProps = {
  mobileUrl?: string
  desktopUrl?: string
  alt: string
}

/**
 * Generate an Image type from a mobile/desktop URL.
 */
export function generatePictureSource({
  mobileUrl,
  desktopUrl,
  alt,
}: GenerateImageTypeFromUrlProps): Image {
  const set = []

  if (mobileUrl) {
    set.push({
      url: mobileUrl,
      media: Media.Mobile,
    })
  }

  if (desktopUrl) {
    set.push({
      url: desktopUrl,
      media: Media.Desktop,
    })
  }

  return {
    alt,
    set,
  }
}
